import * as HLF from "html-living-framework";
import * as Constant from "../Data/Constants";
import * as Topics from "../Data/Topics";

export default class PausePopup extends HLF.Popup {
    /** @override */
    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this.addChild(HLF.PixiUtils.makeText("Paused", Constant.FONT_LUNA, 36, HLF.Colour.WHITE.toHex()));
    }

    /** @inheritdoc */
    protected AnimateIn(pCallback: () => void): void {
        pCallback();
    }

    /** @inheritdoc */
    protected AnimateOut(pCallback: () => void): void {
        pCallback();
    }

}
